import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

const DEFAULTS = {
  secure_email: "secure@diplomaticvaults.co",
  phone: "+44 (0) 20 0000 4820",
  address: "1 Sovereign Wharf\nCanary Wharf, London, UK",
};

export function useCompanyInfo() {
  const [company, setCompany] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  // Deps intentionally empty: `api` is a stable module-level axios instance;
  // `cancelled` is a closure-local flag, not a reactive value; setters are
  // stable per React. Fetch runs once on mount.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/company");
        if (!cancelled) setCompany(data);
      } catch (err) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("useCompanyInfo: falling back to defaults", err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { company, loading, setCompany };
}
